"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylePropertyNameToCssSyntax = exports.styleObjectToCss = exports.wrapInHtml = exports.unEscapeHtmlAttribute = exports.escapeHtmlAttribute = void 0;
function escapeHtmlAttribute(code) {
    return code.replace(/\"/gim, '&quot;');
}
exports.escapeHtmlAttribute = escapeHtmlAttribute;
function unEscapeHtmlAttribute(code) {
    return code.replace(/\&quot\;/gim, '"');
}
exports.unEscapeHtmlAttribute = unEscapeHtmlAttribute;
function wrapInHtml(s) {
    return "\n  <!DOCTYPE html>\n<html>\n<head>\n  <meta charset=\"utf-8\" />\n  <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\">\n  <title>title</title>\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n</head>\n<body>\n" + s + "\n</body>\n</html>\n";
}
exports.wrapInHtml = wrapInHtml;
/**
 * transform an object like `{fooBar: 'value 123'}` to an string like `foo-bar: value 123`.
 */
function styleObjectToCss(o, propertiesSeparator) {
    if (propertiesSeparator === void 0) { propertiesSeparator = ''; }
    return Object.keys(o)
        .map(function (p) { return stylePropertyNameToCssSyntax(p) + ": " + o[p] + ";"; })
        .join(propertiesSeparator);
}
exports.styleObjectToCss = styleObjectToCss;
/**
 * Transform a string like `fooBar` to `foo-bar`
 */
function stylePropertyNameToCssSyntax(s) {
    var t;
    while ((t = /([A-Z])/.exec(s))) {
        s = s.substring(0, t.index) + '-' + t[1].toLowerCase() + s.substring(t.index + 1, s.length);
    }
    return s;
}
exports.stylePropertyNameToCssSyntax = stylePropertyNameToCssSyntax;
//# sourceMappingURL=html.js.map